module.exports = __webpack_public_path__ + "static/media/boombassadorLogo.e3f10636.png";